export default {
  // 获取授权信息
  getJinDaShiUserInfo: 'get /auth/data'
}
